import Vue from 'vue'
import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import { i18n, resetI18nLocale, handleLocalStorage } from "@/i18n/index";
import { commonParams } from "@/config/common"
import { requestJson } from '../request'
import { LanguageContent } from './lang'
import { Header } from '@/models/header.js'

class Language{
    static langConfig = null
    static langList = []
    static langData = null

    static async init() {
        await this._initData()
        await this._initLanguage()
    }

    static getConfig() {
        return Language.langConfig
    }

    static getList() {
        return Language.langList
    }

    static getJsonData() {
        return Language.langData
    }

    static async _initData() {
        await this._initLangConfig()
        const langCode = this._getLangCode()
        if(!this._checkLanguageCode(langCode)){
            await Header.switchLanguage(langCode)
        }
    }

    static async _initLanguage() {
        const langCode = this._getLangCode()
        await this._initLangData(langCode)
        this._initUILanguage()
    }

    static async _initLangConfig() {
        if(!Language.langConfig){
            const url = `${ commonParams.PAAS_CONFIG }/config/languageConf.json`
            const res = await requestJson(url)
            Language.langConfig = res.languageConf
            Language.langList = res.languageList
        }
    }

    static _getLangCode() {
        // 优先级：i18nLocale > 浏览器默认语言 > 默认展示语言
        if(!Language.langConfig.isLanguageSwitcher){
            resetI18nLocale()
            return LanguageContent.getPaaSJsonSuffix()
        }
        if(!this._isRelease(LanguageContent.getPaaSJsonSuffix())){
            resetI18nLocale()
        }
        if(handleLocalStorage('get', 'paas_language')){
            return LanguageContent.getPaaSJsonSuffix()
        }
        const browserLangCode = LanguageContent.getLangCodeByBrowser()
        const isBrowserLang = Language.langList.some(lang => lang.languageCode === browserLangCode)
        if(Language.langConfig.isFollowBrowser === 1 && isBrowserLang){
            return browserLangCode
        }
        return Language.langConfig.defaultLanguage
    }

    static _checkLanguageCode(langCode){
        return LanguageContent.getI18nLocaleByPaaSJsonSuffix(langCode) === i18n.locale
    }

    static _isRelease(langCode){
        return Language.langList.find(lang => lang.languageCode === langCode)
    }

    static async _initLangData(langCode) {
        if(!Language.langData){
            const url = `${ commonParams.PAAS_CONFIG }/language/${ langCode }.json`
            Language.langData = await requestJson(url)
            const paasHomeJson = { 'paas_home': Language.langData }
            const target = i18n.messages[i18n.locale] || i18n.messages.en
            const message = Object.assign(target, paasHomeJson)
            i18n.setLocaleMessage(i18n.locale, message)
        }
    }

    static _initUILanguage() {
        if(i18n.locale == 'en') {
            Vue.use(ElementUI, { locale: enLocale })
        }else if(i18n.locale === 'zh_TW') {
            Vue.use(ElementUI, { locale: zhTWLocale })
        }else {
            Vue.use(ElementUI, { locale: zhLocale })
        }
    }
}

export { Language }


// WEBPACK FOOTER //
// ./src/lib/util/language.js